import { createContext, useCallback, useRef } from 'react';
import { CONST_FUNCTION } from 'utilities/consts/variable-types.js';
import { manageSiteVersion } from 'utilities/fetch/version-request.js';

type AppVersionContextProps = {
  /** Run fetch version */
  checkVersion(): void;
};

export const AppVersionContext = createContext<AppVersionContextProps>({
  checkVersion: CONST_FUNCTION,
});

/**
 * Use on Mobile Heading on Secondary Layout to Display Warnings
 * Each mobile header needs its own unique context
 * so that the highest severity is displayed for that particular item
 */
export const AppVersionProvider = ({ children }: { children: JSX.Element }) => {
  const hasInit = useRef(false);
  const appVersion = useRef(__VERSION__);
  /**
   * When first loaded we dont want to make a call on first page request as its just loaded
   * We do it for every subsequent request
   */

  const checkVersion = useCallback(async () => {
    if (hasInit.current) {
      manageSiteVersion(appVersion.current);
    }
    hasInit.current = true;
  }, []);

  return <AppVersionContext.Provider value={{ checkVersion }}>{children}</AppVersionContext.Provider>;
};
